import { SECTION1 } from './section1';
import { SECTION10 } from './section10';
import { SECTION11 } from './section11';
import { SECTION12 } from './section12';
import { SECTION13 } from './section13';
import { SECTION14 } from './section14';
import { SECTION2 } from './section2';
import { SECTION3 } from './section3';
import { SECTION4 } from './section4';
import { SECTION5 } from './section5';
import { SECTION6 } from './section6';
import { SECTION7 } from './section7';
import { SECTION8 } from './section8';
import { SECTION9 } from './section9';

const IAR = {
  SECTION1,
  SECTION2,
  SECTION3,
  SECTION4,
  SECTION5,
  SECTION6,
  SECTION7,
  SECTION8,
  SECTION9,
  SECTION10,
  SECTION11,
  SECTION12,
  SECTION13,
  SECTION14,
};

export default IAR;
